import { DialogContentScrollable } from "@shared/EDS/components/Dialog";
import { MessageBar } from "@shared/EDS/components/MessageBar";
import { JSX } from "react";

interface EmptyPlanContentProps {
  readonly onClose: () => void;
}
export function EmptyPlanContent({ onClose }: EmptyPlanContentProps): JSX.Element {
  return (
    <DialogContentScrollable height="100%">
      <MessageBar messageBarType="warning">
        Er is nog geen plan ingeladen. Laad eerst een plan in.
      </MessageBar>
      {/* Set a fixed size, otherwise it adds a scrollbar for 0.3px for some reason. */}
      <div className="flex h-[60px] justify-end pt-m">
        <tractie-button
          data-testid="empty-plan-close-button"
          level="primary"
          onClick={onClose}
          autoFocus
        >
          Sluiten
        </tractie-button>
      </div>
    </DialogContentScrollable>
  );
}
